import { useLocation, Navigate } from "react-router-dom";
import ApiService from "../api/ApiService";
import { ReactElement } from "react";

interface AuthRouteProps {
  element: ReactElement;
};

export const AuthRoute = ({ element }: AuthRouteProps) => {
  const location = useLocation();

  return ApiService.isAuthenticated() ? (
    element
  ) : (
    <Navigate to="/register" replace state={{ from: location }} />
  );
};
